import { useState } from "react";

import { Button } from "./button";
import { ClickedOutside } from "./clicked-outside";

import "./context-menu.css";

export function ContextMenu(props) {
    const [open, setOpen] = useState(false);

    const align = props.align || "";
    const className = props.class || "";
    const isOpen = open ? "open" : "";

    function clickedOutside() {
        setOpen(false);
    }

    function toggleOpen() {
        setOpen(!open);
    }

    return (
        <ClickedOutside clickedOutside={() => clickedOutside()}>
            <div className={`context-menu ${isOpen} ${className}`} align={align}>
                <Button
                    variant={props.buttonVariant || "icon"}
                    size={props.buttonSize}
                    icon={props.icon}
                    disabled={props.disabled}
                    readonly={props.readonly}
                    loading={props.loading}
                    clicked={() => toggleOpen()}>
                    {props.buttonContent}
                </Button>
                {open &&
                    <div className="context-menu-content">
                        {props.children}
                    </div>
                }
            </div>
        </ClickedOutside>
    );
}